var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUlasim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#47B8B5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.063 14.89a1.75 1.75 0 01-.563-1.285v-5.79C6.5 5.79 8.514 5.5 11 5.5s4.5.29 4.5 2.316v5.79c0 .509-.22.966-.563 1.284v.742c0 .48-.382.868-.843.868-.467 0-.844-.394-.844-.868v-.29h-4.5v.29c0 .48-.377.868-.844.868a.855.855 0 01-.843-.868v-.742zM7.5 13.5c0 .553.447 1 1 1 .553 0 1-.447 1-1 0-.553-.447-1-1-1-.553 0-1 .447-1 1zm6 1c-.553 0-1-.447-1-1 0-.553.447-1 1-1 .553 0 1 .447 1 1 0 .553-.447 1-1 1zm-6-3h7v-3h-7v3z",
    fill: "#fff"
  })));
}
export default SvgUlasim;